// Dashboard scene has no sagas
export default function* dashboardSaga() {
  yield;
}
